import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { httpClient } from '@/api/http-client'
import { TaxPaymentSlip } from '@/types'

export type RegisterTaxPaymentSlipDownloadParams = {
  company_key: string
  slip_key: string
}

export async function registerTaxPaymentSlipDownload({
  company_key,
  slip_key,
}: RegisterTaxPaymentSlipDownloadParams) {
  const response = await httpClient('accounting-dealer').post<TaxPaymentSlip>(
    `/v3/company/${company_key}/tax-payment-slips/${slip_key}/download`,
  )

  return response.data
}

export function useRegisterTaxPaymentSlipDownload(
  options?: UseMutationOptions<
    TaxPaymentSlip,
    AxiosError,
    RegisterTaxPaymentSlipDownloadParams
  >,
) {
  return useMutation({
    mutationFn: registerTaxPaymentSlipDownload,
    ...options,
  })
}
